const JOB_LIST_SIGNAL_EVENT = 'easyhireai:job-list-updated'

export type JobListSignalReason =
  | 'created'
  | 'updated'
  | 'renamed'
  | 'status-changed'
  | 'deleted'

export interface JobListSignalPayload {
  reason: JobListSignalReason
  jobId?: string
}

export const emitJobListSignal = (payload: JobListSignalPayload) => {
  window.dispatchEvent(new CustomEvent<JobListSignalPayload>(JOB_LIST_SIGNAL_EVENT, { detail: payload }))
}

export const onJobListSignal = (listener: (payload: JobListSignalPayload) => void) => {
  const handler = (event: Event) => {
    const detail = (event as CustomEvent<JobListSignalPayload>).detail
    if (!detail) return
    listener(detail)
  }
  window.addEventListener(JOB_LIST_SIGNAL_EVENT, handler)
  return () => window.removeEventListener(JOB_LIST_SIGNAL_EVENT, handler)
}
